"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var embedTypes = {
  YOUTUBE: 'youtube',
  CHEDDAR_VIDEO: 'cheddar',
  FACEBOOK: 'facebook',
  UGC_CAROUSEL: 'ugc_carousel',
  UGC_FORM: 'ugc_form',
  STORYLIST: 'story-list'
};
var _default = embedTypes;
exports["default"] = _default;